module.exports = __webpack_public_path__ + "img/hand-icon.abf79013.svg";